var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonPlasticToys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pacifier-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M38.965,217.6A8.53,8.53,0,1,0,50.35,228.984a.534.534,0,0,0-.962-.463,7.463,7.463,0,1,1-9.96-9.961.533.533,0,0,0-.464-.961Z",
    transform: "translate(-32 -203.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M20.907,15.68a.533.533,0,0,0,.852.641,7.432,7.432,0,0,1,3.437-2.47c4.324-1.081,6.8-3.6,6.8-6.917a6.912,6.912,0,0,0-2.022-4.889s0-.01-.009-.013-.01-.005-.014-.01A6.911,6.911,0,0,0,25.067,0C21.752,0,19.23,2.48,18.15,6.8c-.362,1.444-2.552,3.663-3.728,4.731L8.377,5.489a2.043,2.043,0,0,0-1.444-.556A2.043,2.043,0,0,0,5.49,5.49L4.423,6.556a2.122,2.122,0,0,0,0,2.887L6.5,11.52A10.663,10.663,0,1,0,20.48,25.5l2.077,2.077a2.152,2.152,0,0,0,2.887,0l1.067-1.067a2.152,2.152,0,0,0,0-2.887L15.177,12.289c1.025-.936,3.547-3.386,4.007-5.226.56-2.239,2.069-6,5.883-6a5.84,5.84,0,0,1,3.752,1.361l-.4.4a.533.533,0,0,0,.755.754l.4-.4a5.84,5.84,0,0,1,1.361,3.751c0,3.814-3.756,5.323-6,5.883A8.388,8.388,0,0,0,20.907,15.68ZM10.667,30.933A9.6,9.6,0,0,1,7.32,12.341L19.659,24.679A9.583,9.583,0,0,1,10.667,30.933Zm15.09-6.556a1.1,1.1,0,0,1,0,1.379L24.69,26.823a1.1,1.1,0,0,1-1.379,0L5.177,8.689a1.071,1.071,0,0,1,0-1.379L6.244,6.244A.991.991,0,0,1,6.933,6a.987.987,0,0,1,.689.243Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M445.319,106.213a.531.531,0,0,0,.408-.19,4.8,4.8,0,0,0,1.126-3.09.533.533,0,0,0-1.067,0,3.738,3.738,0,0,1-.875,2.4.533.533,0,0,0,.407.877Z",
    transform: "translate(-416.987 -96)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonPlasticToys);
export default __webpack_public_path__ + "static/media/nonPlasticToys.2977ca4ececf5bca379f2300bc26bbda.svg";
export { ForwardRef as ReactComponent };